import { render, staticRenderFns } from "./minatKepribadian.vue?vue&type=template&id=1e576210&scoped=true&"
import script from "./minatKepribadian.vue?vue&type=script&lang=js&"
export * from "./minatKepribadian.vue?vue&type=script&lang=js&"
import style0 from "./minatKepribadian.vue?vue&type=style&index=0&id=1e576210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e576210",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VProgressCircular})
